import { Node as Tag } from "../../../node";
import { RegisterWidget, Widget } from "../../lib/widget";
import { Attribute } from '../../lib/attributes';
import SwitchIcon from '../../../images/icons/slider.svg'
import { TagAttribute } from "../../lib/tag";
import type { TagDefinition } from "../../lib/tag";
import template from './slider.html';
import { ColorInput } from "../../../views/attributeeditorview";

@RegisterWidget({tag: 'se-slider', displayName: 'Slider', template: template, icon: SwitchIcon, section: 'Input'})
export class Slider extends Widget {
    protected valueElement: HTMLDivElement;
    slider: HTMLInputElement;
    protected _value: number = 0;
    onchange: ()=>void = ()=>{};
    oninput: ()=>void = ()=>{};
    @Attribute({
        displayName: 'Rail Color',
        getInput: (name, parent, property, getValue, onSettingChangedCallback, tooltip) => new ColorInput(name, parent, property, getValue, onSettingChangedCallback, tooltip)
    }) backgroundColor: string = '#000000';
    @Attribute({
        displayName: 'Thumb Color',
        getInput: (name, parent, property, getValue, onSettingChangedCallback, tooltip) => new ColorInput(name, parent, property, getValue, onSettingChangedCallback, tooltip)
    }) accentColor: string = '#555555';

    @Attribute({displayName: 'Disabled'}) disabled : boolean = false;
    @Attribute({displayName: 'Min'}) min : number;
    @Attribute({displayName: 'Max'}) max : number;
    @Attribute({displayName: 'Step'}) step : number;

    protected connectedCallback(): void {
        this.slider = this.shadowRoot?.getElementById('slider') as HTMLInputElement;
        this.slider.oninput = () => {
            this._value = parseFloat(this.slider.value);
            this.onSliderInput()
            this.oninput();
        }
        this.slider.onchange = () => this.onchange()
        this.style.setProperty('--background-color', this.backgroundColor);
        this.style.setProperty('--accent-color', this.accentColor);
    }

    protected onSliderInput() {}

    set value(v: number) {
        this._value = v;
        this.slider.value = v.toString();
    }

    get value() {
        return this._value;
    }
}

@RegisterWidget({tag: 'se-tag-slider', displayName: 'Tag Slider', icon: SwitchIcon, section: 'Input', editor: true})
export class TagSlider extends Slider {
    @TagAttribute({
        displayName: 'Value Tag',
        shouldSubscribe: true,
        requiredProperties: ['writeable', 'scaled'],
        supportedTypes: ['numeric']
    }) valueTag: TagDefinition;

    protected onSliderInput() {
        this.valueTag.tag.setPendingValue(this.value, this);
    }

    protected enliven(): void {
        this.slider.disabled = this.disabled;
        this.slider.min = (this.min ?? this.valueTag.tag.engMin)?.toString();
        this.slider.max = (this.max ?? this.valueTag.tag.engMax)?.toString();
        this.slider.step = (this.step ?? this.valueTag.tag.resolution)?.toString();
    }

    update(tag: Tag): void {
        this.value = this.valueTag.tag.getValue(this);
    }
}

